// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"bc64cef1","453":"140c0906"}[chunkId] + ".chunk.js";
};